import type { JswOnboardingData } from '@atlassian/jira-onboarding-core/src/common/types/onboarding-data.tsx';
import { createResource, useResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SOFTWARE_ONBOARDING } from './constants.tsx';

export const jswOnboardingResource = createResource<JswOnboardingData | null>({
	type: RESOURCE_TYPE_SOFTWARE_ONBOARDING,
	getKey: () => 'jsw_onboarding',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-jsw-onboarding", jiraSpaEntry: "async-resource-jsw-onboarding" */ './controllers/get-data'
		),
});

export const useJswOnboardingResource = () =>
	useResource<JswOnboardingData | null>(jswOnboardingResource);
